import { ApolloClient, InMemoryCache, makeVar } from '@apollo/client'

export const cache = new InMemoryCache()

const client = new ApolloClient({
  cache,
  credentials: 'include',
  uri: process.env.REACT_APP_APOLLO_CLIENT_URL
})

export const canUploadAgainVar = makeVar(false)

export default client



// WEBPACK FOOTER //
// ./src/graphql/index.js